import { PHOTO_CATEGORIES_BY_GROUP } from "@/config/photo-categories";

/** Select de categoria de foto, agrupado em Exemplar / Local / Outro. */
export default function PhotoCategorySelect({
  value,
  onChange,
  className,
  id,
  allowEmpty,
  ariaLabel,
}: {
  value: string;
  onChange: (code: string) => void;
  className?: string;
  id?: string;
  allowEmpty?: string;
  ariaLabel?: string;
}) {
  return (
    <select id={id} aria-label={ariaLabel} value={value} onChange={(e) => onChange(e.target.value)} className={className}>
      {allowEmpty !== undefined && <option value="">{allowEmpty}</option>}
      {PHOTO_CATEGORIES_BY_GROUP.map((g) => (
        <optgroup key={g.code} label={g.label}>
          {g.categories.map((c) => (
            <option key={c.code} value={c.code}>
              {c.label}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}
